import React, { useCallback } from 'react';
import { Types } from '@blumtechgroup/blum-ui-utils';
import { FormControl, FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import { Location, ValidationErrors, validationErrors, LocationReducerAction } from '../..';

interface Props {
  location: Location;
  errors: ValidationErrors;
  setErrors: React.Dispatch<React.SetStateAction<ValidationErrors>>;
  dispatch: React.Dispatch<{ type: LocationReducerAction; value: any }>;
}

const StepDetails = ({ location, errors, setErrors, dispatch }: Props): React.ReactElement => {
  const validate = useCallback(
    (field: string) => {
      const errorItems: Types.UnknownObject = {};
      if (field === 'name') {
        errorItems.name = !location.name ? validationErrors.name : false;
      }
      setErrors({ ...errors, ...errorItems });
    },
    [location, errors, setErrors]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={8}>
        <TextField
          data-qa="name-textfield"
          required
          label="Name"
          variant="outlined"
          sx={{ width: '100%' }}
          error={errors.name as boolean}
          helperText={errors.name}
          value={location.name}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => dispatch({ type: LocationReducerAction.NAME, value: event.target.value })}
          onKeyUp={() => validate('name')}
          onBlur={() => validate('name')}
        />
      </Grid>
      <Grid item xs={8}>
        <FormControl>
          <FormControlLabel
            label="Active"
            control={
              <Switch
                checked={location.active}
                color="primary"
                data-qa="active-toggle"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  dispatch({
                    type: LocationReducerAction.ACTIVE,
                    value: event.target.checked,
                  })
                }
                inputProps={{ 'aria-label': 'controlled' }}
              />
            }
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default StepDetails;
